import React from 'react'
import styled from 'styled-components'
import EmailField from 'Event/auth/Login/EmailField'
import Page, {
  StyledPaper,
  StyledFormContainer,
} from 'Event/template/Cards/Login/Page'
import {SignUpProps} from 'Event/auth/SignUp'
import {useCardsTemplate} from 'Event/template/Cards'
import Description from 'Event/auth/SignUp/Description'
import DescriptionText from 'Event/auth/SignUp/Description/DescriptionText'
import SubmitButton from 'Event/auth/SignUp/SubmitButton'
import {useGuestVariables} from 'Event'
import FirstNameField from 'Event/auth/SignUp/FirstNameField'
import LastNameField from 'Event/auth/SignUp/LastNameField'
import PhoneNumberField from 'Event/auth/SignUp/PhoneNumberField'
import SignUpAdditionalFields from 'Event/auth/SignUp/SignUpAdditionalFields'
import ErrorMessage from 'Event/auth/SignUp/ErrorMessage'
import Visible from 'lib/ui/layout/Visible'

export default function SignUp(props: SignUpProps) {
  return (
    <Page isPreview={false}>
      <StyledPaper>
        <StyledFormContainer>
          <Content {...props} />
        </StyledFormContainer>
      </StyledPaper>
    </Page>
  )
}

export function Content(props: SignUpProps) {
  const {signUp} = useCardsTemplate()
  const v = useGuestVariables()

  return (
    <>
      <Description
        aria-label="event sign up description"
        Component={SignUpDescriptionText}
      >
        {v(signUp.description)}
      </Description>
      <form onSubmit={props.onSubmit}>
        <FirstNameField {...props} />
        <LastNameField {...props} />
        <EmailField {...props} />
        <Visible when={signUp.hasPhoneNumberField}>
          <PhoneNumberField {...props} />
        </Visible>
        <SignUpAdditionalFields {...props} />
        <ErrorMessage error={props.responseError?.message} />
        <SubmitButton {...props} />
      </form>
    </>
  )
}

const SignUpDescriptionText = styled(DescriptionText)`
  text-align: left;
  margin-bottom: ${(props) => props.theme.spacing[4]};
`
